import { ElementGroup } from './elementGroup';
import { EquipmentElement } from './equipmentElement';
import { EquipmentElements } from './equipmentElements';
import { Utils } from '../../../core/services/utils.service';

export interface IElementGroup {
	name: ElementGroup;
	list: Array<EquipmentElement>;
}

export class ElementsList {
	list: Array<EquipmentElement>;
	draggableElements: { front: Array<EquipmentElements>; top: Array<EquipmentElements>; } = {
		front: [
			EquipmentElements.BaseRectangle,
			EquipmentElements.BaseTrapeze,
			EquipmentElements.BackWall,
			EquipmentElements.CentralPillar,
			EquipmentElements.HookWall,
			EquipmentElements.PerforatedWall,
			EquipmentElements.SideWalls,
			EquipmentElements.Showcase,
			EquipmentElements.HookPanel,
			EquipmentElements.Perforation,
			EquipmentElements.Shelf,
			EquipmentElements.AngleShelf,
			EquipmentElements.HangBar,
			EquipmentElements.Partition,
			EquipmentElements.Hook
		],
		top: [
			EquipmentElements.Box,
			EquipmentElements.SlicedBox,
			EquipmentElements.Partition
		]
	};

	constructor() {
		this.list = [
			// bases
			new EquipmentElement({
				icon: 'elementBaseRectangle',
				name: 'RECTANGLE_BASE',
				type: EquipmentElements.BaseRectangle,
				behavior: 'auto',
				visible: true,
				group: ElementGroup.BaseElement,
				deniedRepresentations: ['top'],
				allowedTypes: [EquipmentElements.Box, EquipmentElements.SlicedBox, EquipmentElements.Partition],
				deniedTypes: [],
				requiredTypes: []
			}),
			new EquipmentElement({
				icon: 'elementBaseTrapeze',
				name: 'TRAPEZE_BASE',
				type: EquipmentElements.BaseTrapeze,
				behavior: 'auto',
				visible: true,
				group: ElementGroup.BaseElement,
				deniedRepresentations: ['top'],
				allowedTypes: [EquipmentElements.Box, EquipmentElements.SlicedBox, EquipmentElements.Partition],
				deniedTypes: [],
				requiredTypes: []
			}),
			// additional elements
			new EquipmentElement({
				icon: 'elementBackWall',
				name: 'BACK_WALL',
				type: EquipmentElements.BackWall,
				behavior: 'auto',
				visible: true,
				group: ElementGroup.AdditionalElement,
				deniedRepresentations: ['top'],
				allowedTypes: [
					EquipmentElements.Shelf,
					EquipmentElements.AngleShelf,
					EquipmentElements.HangBar,
					EquipmentElements.HookPanel,
					EquipmentElements.Perforation
				],
				deniedTypes: [],
				requiredTypes: [[EquipmentElements.BaseRectangle, EquipmentElements.BaseTrapeze]]
			}),
			new EquipmentElement({
				icon: 'elementCentralPillar',
				name: 'CENTRAL_PILLAR',
				type: EquipmentElements.CentralPillar,
				behavior: 'auto',
				visible: true,
				group: ElementGroup.AdditionalElement,
				deniedRepresentations: ['top'],
				allowedTypes: [EquipmentElements.Shelf],
				deniedTypes: [],
				requiredTypes: [[EquipmentElements.BaseRectangle]]
			}),
			new EquipmentElement({
				icon: 'elementHookWall',
				name: 'HOOK_WALL',
				type: EquipmentElements.HookWall,
				behavior: 'auto',
				visible: true,
				group: ElementGroup.AdditionalElement,
				deniedRepresentations: ['top'],
				allowedTypes: [EquipmentElements.Hook],
				deniedTypes: [],
				requiredTypes: [[EquipmentElements.BaseRectangle, EquipmentElements.BaseTrapeze]]
			}),
			new EquipmentElement({
				icon: 'elementPerforatedWall',
				name: 'PERFORATION_WALL',
				type: EquipmentElements.PerforatedWall,
				behavior: 'auto',
				visible: true,
				group: ElementGroup.AdditionalElement,
				deniedRepresentations: ['top'],
				allowedTypes: [],
				deniedTypes: [],
				requiredTypes: [[EquipmentElements.BaseRectangle, EquipmentElements.BaseTrapeze]]
			}),
			new EquipmentElement({
				icon: 'elementSideWalls',
				name: 'SIDES_WALL',
				type: EquipmentElements.SideWalls,
				behavior: 'auto',
				visible: true,
				group: ElementGroup.AdditionalElement,
				deniedRepresentations: ['top'],
				allowedTypes: [],
				deniedTypes: [],
				requiredTypes: [
					[EquipmentElements.BaseRectangle, EquipmentElements.BaseTrapeze],
					[EquipmentElements.BackWall, EquipmentElements.HookWall, EquipmentElements.PerforatedWall]
				]
			}),
			new EquipmentElement({
				icon: 'elementHookPanel',
				name: 'HOOK_PANEL',
				type: EquipmentElements.HookPanel,
				behavior: 'custom',
				visible: true,
				group: ElementGroup.AdditionalElement,
				deniedRepresentations: ['top'],
				allowedTypes: [EquipmentElements.Hook],
				deniedTypes: [],
				requiredTypes: [
					[EquipmentElements.BaseRectangle, EquipmentElements.BaseTrapeze],
					[EquipmentElements.BackWall]
				]
			}),
			new EquipmentElement({
				icon: 'elementPerforation',
				name: 'PERFORATION',
				type: EquipmentElements.Perforation,
				behavior: 'custom',
				visible: true,
				group: ElementGroup.AdditionalElement,
				deniedRepresentations: ['top'],
				allowedTypes: [],
				deniedTypes: [],
				requiredTypes: [
					[EquipmentElements.BaseRectangle, EquipmentElements.BaseTrapeze],
					[EquipmentElements.BackWall]
				]
			}),
			new EquipmentElement({
				icon: 'elementPartition',
				name: 'PARTITION',
				type: EquipmentElements.Partition,
				behavior: 'custom',
				visible: true,
				group: ElementGroup.AdditionalElement,
				deniedRepresentations: ['front'],
				allowedTypes: [],
				deniedTypes: [],
				requiredTypes: [
					[EquipmentElements.BaseRectangle, EquipmentElements.BaseTrapeze],
					[
						EquipmentElements.Shelf,
						EquipmentElements.AngleShelf,
						EquipmentElements.BaseRectangle,
						EquipmentElements.BaseTrapeze
					]
				]
			}),
			new EquipmentElement({
				icon: 'elementShowcase',
				name: 'SHOWCASE',
				type: EquipmentElements.Showcase,
				behavior: 'auto',
				visible: true,
				group: ElementGroup.AdditionalElement,
				deniedRepresentations: ['top'],
				allowedTypes: [EquipmentElements.Shelf, EquipmentElements.AngleShelf],
				deniedTypes: [],
				requiredTypes: [[EquipmentElements.BaseRectangle, EquipmentElements.BaseTrapeze]]
			}),
			// main elements
			new EquipmentElement({
				icon: 'elementShelf',
				name: 'SHELF',
				type: EquipmentElements.Shelf,
				behavior: 'custom',
				visible: true,
				group: ElementGroup.MainElement,
				deniedRepresentations: ['top'],
				allowedTypes: [EquipmentElements.Box, EquipmentElements.SlicedBox, EquipmentElements.Partition],
				deniedTypes: [],
				requiredTypes: [
					[EquipmentElements.BaseRectangle, EquipmentElements.BaseTrapeze],
					[EquipmentElements.BackWall, EquipmentElements.CentralPillar, EquipmentElements.Showcase]
				]
			}),
			new EquipmentElement({
				icon: 'elementShelfAngle',
				name: 'ANGLE_SHELF',
				type: EquipmentElements.AngleShelf,
				behavior: 'custom',
				visible: true,
				group: ElementGroup.MainElement,
				deniedRepresentations: ['top'],
				allowedTypes: [EquipmentElements.Box, EquipmentElements.SlicedBox, EquipmentElements.Partition],
				deniedTypes: [],
				requiredTypes: [
					[EquipmentElements.BaseRectangle],
					[EquipmentElements.BackWall, EquipmentElements.Showcase]
				]
			}),
			new EquipmentElement({
				icon: 'elementHangBar',
				name: 'HANG_BAR',
				type: EquipmentElements.HangBar,
				behavior: 'custom',
				visible: true,
				group: ElementGroup.MainElement,
				deniedRepresentations: ['top'],
				allowedTypes: [EquipmentElements.Hook],
				deniedTypes: [],
				requiredTypes: [
					[EquipmentElements.BaseRectangle, EquipmentElements.BaseTrapeze],
					[EquipmentElements.BackWall]
				]
			}),
			new EquipmentElement({
				icon: 'elementBox',
				name: 'BOX',
				type: EquipmentElements.Box,
				behavior: 'custom',
				visible: true,
				group: ElementGroup.MainElement,
				deniedRepresentations: ['front'],
				allowedTypes: [],
				deniedTypes: [],
				requiredTypes: [
					[EquipmentElements.BaseRectangle, EquipmentElements.BaseTrapeze],
					[
						EquipmentElements.Shelf,
						EquipmentElements.AngleShelf,
						EquipmentElements.BaseRectangle,
						EquipmentElements.BaseTrapeze
					]
				]
			}),
			new EquipmentElement({
				icon: 'elementBox',
				name: 'SLICED_BOX',
				type: EquipmentElements.SlicedBox,
				behavior: 'custom',
				visible: true,
				group: ElementGroup.MainElement,
				deniedRepresentations: ['front'],
				allowedTypes: [],
				deniedTypes: [],
				requiredTypes: [
					[EquipmentElements.BaseRectangle, EquipmentElements.BaseTrapeze],
					[
						EquipmentElements.Shelf,
						EquipmentElements.AngleShelf,
						EquipmentElements.BaseRectangle,
						EquipmentElements.BaseTrapeze
					]
				]
			}),
			new EquipmentElement({
				icon: 'elementHook',
				name: 'HOOK',
				type: EquipmentElements.Hook,
				behavior: 'custom',
				visible: true,
				group: ElementGroup.MainElement,
				deniedRepresentations: ['top'],
				allowedTypes: [],
				deniedTypes: [],
				requiredTypes: [
					[EquipmentElements.BaseRectangle, EquipmentElements.BaseTrapeze],
					[EquipmentElements.HookWall, EquipmentElements.HookPanel, EquipmentElements.HangBar]
				]
			}),
			new EquipmentElement({
				icon: '',
				name: 'HOLE',
				type: EquipmentElements.Hole,
				behavior: 'custom',
				visible: false,
				group: ElementGroup.MainElement,
				deniedRepresentations: ['top'],
				allowedTypes: [],
				deniedTypes: [],
				requiredTypes: [
					[EquipmentElements.BaseRectangle, EquipmentElements.BaseTrapeze],
					[EquipmentElements.PerforatedWall, EquipmentElements.Perforation]
				]
			})
		];
	}

	get Groups(): Array<IElementGroup> {
		return Utils.groupBy(this.list, 'group')
			.map((group: Array<EquipmentElement>): IElementGroup => {
				return { name: group[0].group, list: group }
			})
			.sort((a: IElementGroup, b: IElementGroup): number => {
				if (a.name === ElementGroup.BaseElement) return -1;
				if (b.name === ElementGroup.BaseElement) return 1;
				if (a.name === ElementGroup.MainElement) return -1;
				if (b.name === ElementGroup.MainElement) return 1;
			});
	}

	getParent(type: EquipmentElements): EquipmentElement {
		return this.list.find((el: EquipmentElement): boolean => el.type === type);
	}
}